import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M13.17,11.672a1.272,1.272,0,0,0-.39.06l-1.29-1.29a3.618,3.618,0,0,0,.26-1.36,3.753,3.753,0,0,0-3-3.67V4.122a1.476,1.476,0,0,0,.75-1.29,1.5,1.5,0,1,0-3,0,1.476,1.476,0,0,0,.75,1.29v1.29a3.753,3.753,0,0,0-3,3.67,3.567,3.567,0,0,0,.26,1.35l-1.49,1.49a1.345,1.345,0,0,0-.35-.05,1.4,1.4,0,1,0,1.39,1.4.986.986,0,0,0-.03-.24l1.31-1.31a3.742,3.742,0,0,0,5.31.01l1.07,1.07a1.5,1.5,0,1,0,1.45-1.13ZM8,11.332a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8,11.332Z';
const draw24px = 'M19,17.55a2.052,2.052,0,0,0-.78.16l-1.99-1.99a4.758,4.758,0,0,0-3.48-6.86V6.43a2.051,2.051,0,1,0-1.5-.04V8.86a4.758,4.758,0,0,0-3.48,6.86L5.78,17.71A2.052,2.052,0,0,0,5,17.55a2,2,0,1,0,2,2,2.052,2.052,0,0,0-.16-.78l1.83-1.83a4.757,4.757,0,0,0,6.66,0l1.83,1.83a2.052,2.052,0,0,0-.16.78,2,2,0,1,0,2-2Zm-7-.75a3.25,3.25,0,1,1,3.25-3.25A3.256,3.256,0,0,1,12,16.8Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const DotSpokeThreeIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'dotSpokeThree'));
DotSpokeThreeIcon.displayName = 'DotSpokeThreeIcon';
DotSpokeThreeIcon.propTypes = Icon.propTypes;
DotSpokeThreeIcon.renderIcon = props => /*#__PURE__*/React.createElement(DotSpokeThreeIcon, props);
export default DotSpokeThreeIcon;
//# sourceMappingURL=DotSpokeThreeIcon.js.map